module.exports = __webpack_public_path__ + "7063913433f0503670dcd6130c0bd413.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/god-splitter.png
// module id = 352
// module chunks = 0